import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

import Standard from '../Standard/Standard';
import Timeline from '../Timeline/Timeline';
import Flexible from '../Flexible/Flexible';
import Wheel from '../Wheel/Wheel';
// import NavBox from '../NavBox/NavBox';
import GroupNavStage from '../GroupNavStage/GroupNavStage';
import NavToGroup from '../NavToGroup/NavToGroup';
import SplitPanel from '../SplitPanel/SplitPanel';
import LauncherMenu from '../LauncherMenu/LauncherMenu';
import Digital360 from '../Digital360/Digital360';
import FullScreen from '../FullScreen/FullScreen';
import UnityDisplay from '../UnityDisplay/UnityDisplay';

import * as actions from '../../actions/index';
import icons from '../../data/icons';

import './Stage.css';

class Stage extends Component {
	constructor(props) {
		super(props);
		this.goBack = this.goBack.bind(this);
	}

	goBack() {
		const backTo = this.props && this.props.backTo;
		if(backTo) {
			const goToSection = (backTo && backTo.section > -1) ? backTo.section : this.props.currentSection;
			this.props.goToSection(goToSection);
			
			const goToGroup = (backTo && backTo.group > -1) ? backTo.group : 0;
			this.props.goToGroup(goToGroup);

			const goToStage = (backTo && backTo.stage > -1) ? backTo.stage : 0;
			this.props.goToStage(goToStage);
		} else {
			this.props.goToSection(this.props.currentSection);
			this.props.goToGroup(0);
		}
	}


	render() {
		//console.log('backTo', this.props.backTo);
		return (
			<section
				className={`stage stage--${this.props.data.type}`}
				id={this.props.data.id}
			>
				{
					this.props.data.type === 'groupNavStage' &&
						<GroupNavStage group={this.props.group} data={this.props.data} />
				}
				{
					this.props.data.type === 'navToGroup' &&
						<NavToGroup group={this.props.data.group} />
				}
				{
					this.props.data.type === 'fullscreen' &&
					<FullScreen data={this.props.data} />
				}
				{
					this.props.data.type === 'digital' &&
					<Digital360 data={this.props.data} />
				}
				{
					this.props.data.type === 'launcher-menu' &&
					<LauncherMenu data={this.props.data} />
				}
				{
					this.props.data.type === 'standard' &&
					<Standard data={this.props.data} />
				}
				{
					this.props.data.type === 'splitPanel' &&
					<SplitPanel data={this.props.data} />
				}
				{
					this.props.data.type === 'unity' &&
					<UnityDisplay data={this.props.data} />
				}
				{
					this.props.data.type === 'flexible' &&
					<Flexible />
				}
				{
					this.props.data.type === 'timeline' &&
					<Timeline data={this.props.data.timeline} title={this.props.data.title} />
				}
				{
					this.props.data.type === 'wheel' &&
					<Wheel />
				}
				{
					false && (this.props.currentGroup > 0 || this.props.currentStage > 0) &&
					this.props.group.id !== 'section0-group0' &&
					<button className="stage__back" onClick={this.goBack}>
						<img
							className="stage__backIcon"
							src={icons.back.svg}
							alt="back"
						/>
						Back
						</button>
				}
			</section>
		);
	}
}


function mapDispatchToProps(dispatch) {
	return {
		goToSection: (sectionID) => {
			dispatch(actions.goToSection(sectionID));
		},
		goToGroup: (groupID) => {
			dispatch(actions.goToGroup(groupID));
		},
		goToStage: (stageID) => {
			dispatch(actions.goToStage(stageID));
		},
	};
}


Stage.propTypes = {
	data: propTypes.shape({
		title: propTypes.string,
		subtitle: propTypes.string,
		type: propTypes.string.isRequired,
		video: propTypes.object,
		imageSequence: propTypes.object,
		images: propTypes.array,
	}),
	group: propTypes.object.isRequired,
	backTo: propTypes.object,
	currentSection: propTypes.number.isRequired,
	currentGroup: propTypes.number.isRequired,
	currentStage: propTypes.number.isRequired,
	goToSection: propTypes.func.isRequired,
	goToGroup: propTypes.func.isRequired,
	goToStage: propTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(Stage);



// WEBPACK FOOTER //
// ./src/components/Stage/Stage.js